import { Injectable } from "@angular/core";
import { HttpClientService } from "src/app/http-confing/http/http-client.service";
import { BehaviorSubject, Observable } from "rxjs";
// import { io } from "socket.io-client";

@Injectable({
  providedIn: "root",
})
export class ChatService {
  socket;
  public message$: BehaviorSubject<string> = new BehaviorSubject("");
  public deletedMessage$: BehaviorSubject<string> = new BehaviorSubject("");
  public contactLastMsg$: BehaviorSubject<string> = new BehaviorSubject("");
  constructor(private http: HttpClientService) {
    // this.socket = io("https://vinci.leadscrm.net:5000");
    // this.socket = io("http://192.168.1.52:6001");
    this.socket = null;
  }

  public getNewMessage = (contactId) => {
    // Temporarily disabled due to socket.io-client removal
    return this.message$.asObservable();
  };

  public getDeletedMessage = (contactId) => {
    // Temporarily disabled due to socket.io-client removal
    return this.deletedMessage$.asObservable();
  };

  public getContactsLastMessage = (companyId) => {
    // Temporarily disabled due to socket.io-client removal
    return this.contactLastMsg$.asObservable();
  };

  disconnectSocket() {
    // Temporarily disabled due to socket.io-client removal
    // if (this.socket) {
    //   this.socket.disconnect();
    // }
  }
  // public disconnectUserEvent() {
  //   return this.socket.disconnect();
  // }

  // public checkSocketConnection() {
  //   let socket = this.socket.connect();
  //   console.log('check 1', socket.connected);
  //   socket.on('connect', function () {
  //     console.log('check 2', socket.connected);
  //   });
  // }

  // sendFacebookPages
  public addFacebookPages(body) {
    return this.http.post(body, "pages");
  }
  // getSavedPages
  public getFacebookPages(page: number = 1, is_paginate?: true) {
    return this.http.get("pages", {
      page: page,
      is_paginate: is_paginate,
    });
  }

  // get page contacts
  getAllMessages(page: number = 1, is_paginate?: true) {
    return this.http.get("contacts", {
      page: page,
      is_paginate: is_paginate,
    });
  }

  // get contact messages
  getUserMessages(contactId, page: number = 1, is_paginate?: true) {
    return this.http.get(`contacts/${contactId}/messages`, {
      page: page,
      is_paginate: is_paginate,
    });
  }
  // send message to contact
  sendMessage(message, contactId) {
    return this.http.post(
      { message: message },
      `contacts/${contactId}/send-message`
    );
  }

  sendWhatsappNumbers(body){
    return this.http.post(
      body,'whatsapp-numbers'
    )
  }
}
